import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Mode} from '../../../models/mode';
import {shareReplay, switchMap} from 'rxjs/operators';
import {ProjectReferenceContractAttributesService} from '../../../services/project-reference-contract-attributes.service';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-prd-contract-attributes',
    templateUrl: './prd-contract-attributes.component.html',
    standalone: false
})
export class PrdContractAttributesComponent implements OnInit, OnDestroy {
    private attributeService = inject<ProjectReferenceContractAttributesService>('ProjectReferenceContractAttributesService' as any);
    private toast = inject(ToastrService);

    private subscriptions: Subscription[] = [];

    @Input() refId!: number;
    @Input() mode$!: Observable<Mode>;

    refresh$ = new BehaviorSubject<void>(undefined);
    contractAttributes$ = this.refresh$.pipe(
        switchMap(() => this.attributeService.getContractAttributes(this.refId)),
        shareReplay({bufferSize: 1, refCount: true})
    );

    form = new UntypedFormGroup({
        contractScope: new UntypedFormControl(null),
        implementation: new UntypedFormControl(null),
        buyerParticipation: new UntypedFormControl(null),
        realizationPosition: new UntypedFormControl(null),
        contractPrecondition: new UntypedFormControl(null),
        methodOfAcquisition: new UntypedFormControl(null),
        contractPrice: new UntypedFormControl(null),
        additionalWork: new UntypedFormControl(null)
    })

    ngOnInit() {
        this.subscriptions.push(
            this.mode$.subscribe(mode => mode === Mode.Edit ? this.form.enable({emitEvent: false}) : this.form.disable({emitEvent: false})),
            this.contractAttributes$.subscribe(attributes => {
                this.form.patchValue({
                    contractScope: attributes.contractScope?.selectedValueId,
                    implementation: attributes.implementation?.selectedValueId,
                    buyerParticipation: attributes.buyerParticipation?.selectedValueId,
                    realizationPosition: attributes.realizationPosition?.selectedValueId,
                    contractPrecondition: attributes.contractPrecondition?.selectedValueId,
                    methodOfAcquisition: attributes.methodOfAcquisition?.selectedValueId,
                    contractPrice: attributes.contractPrice,
                    additionalWork: attributes.additionalWork
                }, {emitEvent: false})
            }),
            this.form.valueChanges.subscribe(async (value) => {
                try {
                    await this.attributeService.putContractAttributes({
                        projectReference: this.refId,
                        ...value
                    }).toPromise()
                    this.refresh$.next();
                } catch (e) {
                    console.error('contractAttribute save failed', e);
                    this.toast.error('Contract kenmerken opslaan mislukt.')
                }
            })
        )
    }

    ngOnDestroy() {
        this.subscriptions.forEach(it => it.unsubscribe());
    }
}
